/* eslint-disable no-console */
const state = {
    isSplitShipment: false,
    splitAddresses: [],
    currentAddressIndex: 0,
    productAssignments: {}, // { cart_item_id: { address_sequence: 1, selected: true } }
    unassignedProducts: [],
    splittingChargePerItem: 0.75, // Default splitting charge
    packagingOptions: {
        boxType: "standard", // 'standard' or 'custom'
        specialHandling: false
    }
};

const mutations = {
    setSplitShipment(state, value) {
        state.isSplitShipment = value;
    },
    setSplitAddresses(state, addresses) {
        state.splitAddresses = addresses;
    },
    addSplitAddress(state, address) {
        state.splitAddresses.push(address);
    },
    updateSplitAddress(state, { index, address }) {
        state.splitAddresses[index] = address;
    },
    deleteSplitAddress(state, index) {
        state.splitAddresses.splice(index, 1);
    },
    setCurrentAddressIndex(state, index) {
        state.currentAddressIndex = index;
    },
    setProductAssignments(state, assignments) {
        state.productAssignments = assignments;
    },
    setUnassignedProducts(state, products) {
        state.unassignedProducts = products;
    },
    setPackagingOptions(state, options) {
        state.packagingOptions = options;
    },
    updateAddressShipping(
        state,
        {
            addressId,
            addressIndex,
            carrierId,
            carrierName,
            carrierImage,
            method,
            cost,
            estimated_delivery_date,
            estimated_delivery_days
        }
    ) {
        // Update shipping details for a specific address
        // Try to find by index first (more reliable), then by ID
        let targetIndex = -1;

        if (addressIndex !== undefined && addressIndex !== null) {
            targetIndex = addressIndex;
        } else if (addressId !== undefined && addressId !== null) {
            targetIndex = state.splitAddresses.findIndex(
                (addr) =>
                    addr.id === addressId ||
                    addr.address_id === addressId ||
                    (addr.id && addr.id.toString() === addressId.toString()) ||
                    (addr.address_id &&
                        addr.address_id.toString() === addressId.toString())
            );
        }

        if (targetIndex !== -1 && targetIndex < state.splitAddresses.length) {
            const address = state.splitAddresses[targetIndex];
            state.splitAddresses[targetIndex] = {
                ...address,
                shipping_carrier_id: carrierId,
                shipping_carrier_name:
                    carrierName !== undefined
                        ? carrierName
                        : address.shipping_carrier_name,
                shipping_carrier_image:
                    carrierImage !== undefined
                        ? carrierImage
                        : address.shipping_carrier_image,
                shipping_method: method,
                shipping_cost: cost,
                estimated_delivery_date:
                    estimated_delivery_date !== undefined
                        ? estimated_delivery_date
                        : address.estimated_delivery_date,
                estimated_delivery_days:
                    estimated_delivery_days !== undefined
                        ? estimated_delivery_days
                        : address.estimated_delivery_days
            };
        } else {
            console.warn(
                "[splitShipment] updateAddressShipping - Address not found:",
                {
                    addressId,
                    addressIndex,
                    availableAddresses: state.splitAddresses.length
                }
            );
        }
    },
    resetSplitShipment(state) {
        state.isSplitShipment = false;
        state.splitAddresses = [];
        state.currentAddressIndex = 0;
        state.productAssignments = {};
        state.unassignedProducts = [];
        state.packagingOptions = {
            boxType: "standard",
            specialHandling: false
        };
    }
};

const getters = {
    isSplitShipment: (state) => state.isSplitShipment,
    splitAddresses: (state) => state.splitAddresses,
    currentAddressIndex: (state) => state.currentAddressIndex,
    productAssignments: (state) => state.productAssignments,
    unassignedProducts: (state) => state.unassignedProducts,
    packagingOptions: (state) => state.packagingOptions
};

export default {
    namespaced: true,
    state,
    mutations,
    getters
};
